interface ContactProps {
  onContactClick: () => void;
}

export default function Contact({ onContactClick }: ContactProps) {
  const handlePhoneCall = () => {
    window.location.href = 'tel:080-6904-5307';
  };

  return (
    <section id="contact" className="px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl lg:text-2xl font-bold text-green-900 mb-6">お問い合わせ</h2>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="text-center mb-6">
            <h3 className="text-lg font-bold text-primary mb-2">工事や求人などお気軽にご相談ください</h3>
            <p className="text-sm text-green-600">無料でお見積りいたします</p>
          </div>
          <div className="space-y-4">
            <div 
              onClick={handlePhoneCall}
              className="flex items-center justify-center bg-primary text-white rounded-lg p-4 cursor-pointer hover:bg-green-700 transition-colors"
            >
              <div className="w-8 h-8 flex items-center justify-center mr-3">
                <i className="ri-phone-line text-lg text-green-100"></i>
              </div>
              <div>
                <p className="text-sm text-green-100">お電話でのお問い合わせ</p>
                <p className="text-lg font-bold text-green-100">080-6904-5307</p>
              </div>
            </div>
            <div className="flex items-center justify-center bg-gray-100 text-gray-700 rounded-lg p-4">
              <div className="w-8 h-8 flex items-center justify-center mr-3">
                <i className="ri-printer-line text-lg text-green-700"></i>
              </div>
              <div>
                <p className="text-sm text-green-700">FAX でのお問い合わせ</p>
                <p className="text-lg font-bold text-green-700">0564-55-8401</p>
              </div>
            </div>
          </div>
          <div className="mt-6">
            <button 
              onClick={onContactClick}
              className="w-full bg-secondary text-white py-3 rounded-lg font-medium cursor-pointer whitespace-nowrap hover:bg-green-700 transition-colors"
            >
              <i className="ri-mail-line mr-2 text-green-100"></i>
              <span className="text-green-100">お問い合わせフォームはこちら</span>
            </button>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <h3 className="font-bold text-green-900 mb-4">対応エリア</h3>
          <div className="space-y-2 text-sm text-green-600">
            <p><span className="font-medium text-green-900">対応エリア:</span>東海エリア その他はご相談ください</p>
            <p><span className="font-medium text-green-900">営業時間:</span>平日 8:00〜17:00</p>
            <p className="text-xs text-primary">緊急時は時間外でも対応いたします</p>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6">
          <h3 className="font-bold text-green-900 mb-4">許可・登録情報</h3>
          <div className="space-y-2 text-sm text-green-600">
            <p><span className="font-medium text-green-900">建設業許可:</span>愛知県知事許可(般ー7)第 75833 号</p>
            <p><span className="font-medium text-green-900">登録電気工事業:</span>愛知県知事登録第 074031 号</p>
            <p><span className="font-medium text-green-900">T番号:</span>T3180301033034</p>
          </div>
        </div>
      </div>
    </section>
  );
}
